import TopNav from 'components/TopNav';
import React from 'react';
import styles from './style.module.scss';
import { Link } from 'react-router-dom';
import { textFooterEnv } from '../../../utils/utils';
import { useSelector } from 'react-redux';


const PreRegisterJob = () => {
  const envInfoList = useSelector((state) => state.envInfo.data);

  const textFooter = () => {
    return textFooterEnv(envInfoList ?? []);
  };

  return (
    <div
      style={{
        overflow: 'auto',
        height: '100vh',
        backgroundColor: 'var(--white)',
        maxWidth: 560,
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <TopNav name={'会員登録案内（J）'} hasBackIcon={true} dir={`${process.env.RAZZLE_PUBLIC_URL}/job-lp`} />
      <React.Fragment>
        <div className={styles.wrapperMain}>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }} className={styles.wrapperBtn}>
            <div style={{ marginBottom: 0 }} className="btn-main btn-submit">
              <Link
                style={{
                  textDecoration: 'unset',
                  color: 'var(--white)',
                  width: '100%',
                  textAlign: 'center'
                }}
                to={`${process.env.RAZZLE_PUBLIC_URL}/register-job`}
              >
                登録に進む
              </Link>
            </div>
          </div>
        </div>
      </React.Fragment>
      <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
        <p style={{ color: 'var(--text3)' }} className="font-3"
           dangerouslySetInnerHTML={{ __html: textFooter() }}></p>
      </div>
    </div>
  );
};

export default PreRegisterJob;
